import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useRef, useState } from "react";
import classNames from "classnames";
import dompurify from "isomorphic-dompurify";
import styles from "./PrizeSpinner.module.scss";
export const PrizeSpinner = ({ drawnIndex, options = [], isLoading, className, title }) => {
    const [optionsHidden, setOptionsHidden] = useState(false);
    const wheel = useRef(null);
    const { sanitize } = dompurify;
    const shouldStopWheel = wheel.current && drawnIndex !== undefined;
    const modifiedOptions = useMemo(() => (options.length === 4 ? new Array(2).fill(options).flat() : options), [options]);
    useEffect(() => {
        if (wheel.current && drawnIndex !== undefined) {
            const rotationValue = `-${360 * 5 + drawnIndex * 45}deg`;
            wheel.current.style.setProperty("--rotation", rotationValue);
            setTimeout(() => {
                setOptionsHidden(true);
            }, 2000);
        }
    }, [drawnIndex]);
    if (!isLoading && drawnIndex === undefined) {
        return (_jsx("div", { className: classNames(styles.title), dangerouslySetInnerHTML: { __html: sanitize(title, { ALLOWED_TAGS: ["b"] }) } }));
    }
    return (_jsx("div", { className: classNames(styles.prizeSpinner, className), children: _jsx("div", { ref: wheel, "data-testid": "wheel", className: classNames(styles.wheel, {
                [styles.spin]: isLoading,
                [styles.finished]: shouldStopWheel,
            }), children: modifiedOptions.map((item, index) => (_jsx("div", { "data-testid": "wheelOption", style: { "--index": index }, className: classNames(styles.option, {
                    [styles.hidden]: optionsHidden && index !== drawnIndex,
                }), children: _jsx("div", { className: styles.text, dangerouslySetInnerHTML: { __html: sanitize(item, { ALLOWED_TAGS: ["b"] }) } }) }, item + index))) }) }));
};
//# sourceMappingURL=PrizeSpinner.js.map